<div>
    <div *ngIf="!spinnerShow">
        <!-- ___ Action ___ -->
        <div class="row m-b-sm" *ngIf="!authService.userIsResident">
            <div class="col-md-5">
                <label>Action</label>
            </div>
            <div class="col-md-7">
                <select class="form-control" name="action" [(ngModel)]="action" (ngModelChange)="onActionChange($event)">
                    <option value="pay" [disabled]="isBookingDateLaterThanCurrent()">
                        Pay for Additional Service
                    </option>
                    <option value="refund"
                            *ngIf="getPaidFees().length > 0 && amenitiesService.selectedItemData.isCanEdit">
                        Refund
                    </option>
                    <option value="waive"
                            *ngIf="getWaivableFees().length > 0 && amenitiesService.selectedItemData.isCanEdit">
                        Waive
                    </option>
                    <option value="charge"
                            *ngIf="getRefundableFees().length > 0 && amenitiesService.selectedItemData.isCanEdit">
                        Charge Security Deposit
                    </option>
                    <option value="extend"
                            *ngIf="getRefundableFeesForExtending().length > 0 && amenitiesService.selectedItemData.isCanEdit">
                        Extend Security Deposit
                    </option>
                    <option value="history" *ngIf="history.length > 0">View Payment History</option>
                </select>
            </div>
        </div>
        <form #form="ngForm"
              (ngSubmit)="(data.paymentMethod == 'credit_card' && action == 'pay') ? clickStripeHiddenButton() : updateNewPaymentMethod()"
              [ngClass]="{'ng-submitted': form.submitted}"
              autocomplete="off">
            <!-- ___ Payment Method ___ -->
            <div class="row m-b-sm" *ngIf="action == 'pay'">
                <div class="col-md-5">
                    <label>Payment Method</label>
                </div>
                <div class="col-md-7">
                    <select class="form-control"
                            name="paymentMethod"
                            [disabled]="bookingHasPaidPayments() || !amenitiesService.selectedItemData.isCanEdit"
                            (ngModelChange)="changePaymentType($event)"
                            [(ngModel)]="data.paymentMethod">
                        <option *ngFor="let method of availablePaymentMethods" [value]="method.value">
                            {{method.displayName}}
                        </option>
                    </select>
                </div>
            </div>
            <div *ngIf="action == 'pay' && data.paymentMethod == 'credit_card'">
                <!-- ___ Stripe Card Info ___ -->
                <div class="m-b-sm m-r-none">
                    <div>
                        <label>Card Info</label>
                    </div>
                    <div class="no-stripe-submit-button">
                        <stripe-payment (setter)="setCard($event)" (onSuccess)="onStripeSuccess()" (onFailure)="onStripeFailure($event)">
                        </stripe-payment>
                    </div>
                </div>
            </div>

            <hr *ngIf="!authService.userIsResident && action != 'extend'">

            <div class="row m-b-sm fees-container m-r-none"
                 [ngStyle]="{'display': fee.active && action != 'history' ? '' : 'none'}"
                 *ngFor="let fee of amenityFees; let index = index">
                <div class="img-checkbox">
                    <span [ngClass]="{'col-sm-7' : action == 'pay', 'col-sm-8' : action != 'pay'}">
                        <input type="checkbox"
                               id="feeRequiredDetailedView{{index}}"
                               (change)="selectCheckbox($event, index)"
                               name="feeRequired{{index}}"
                               [hidden]="fee.waived"
                               [disabled]="!amenitiesService.selectedItemData.isCanEdit ||
                                           (action == 'pay' && (ifRequired(fee) || fee.status)) ||
                                           (action == 'charge' && (fee.penalty || fee.maxPenaltyAmount === null))"
                               [(ngModel)]="fee.include"
                               (ngModelChange)="removePaidStatus($event, fee)">
                        <label [title]="(action == 'charge' && fee.penalty) ? 'Was already charged' : ((action == 'charge' && fee.maxPenaltyAmount === null) ? 'This payment has not been held yet' : '')"
                               class="with-checkbox clickable"
                               for="feeRequiredDetailedView{{index}}">
                            <svg-checked [hidden]="fee.waived"></svg-checked>
                            {{fee.name}}{{fee.refundable ? ' (Refundable)': ''}}
                        </label>
                    </span>
                    <span class="col-sm-3 clickable" *ngIf="!fee.waived">
                        <input type="checkbox"
                               id="feePaidDetailedView{{index}}"
                               [disabled]="!fee.include || data.paymentMethod == 'credit_card' || fee.originallyPaid || fee.waived || !amenitiesService.selectedItemData.isCanEdit"
                               name="feePaid{{index}}"
                               [(ngModel)]="fee.status">
                        <label class="with-checkbox clickable"
                               for="feePaidDetailedView{{index}}"
                               style="margin-right: 5px;"
                               *ngIf="action == 'pay'">
                            <svg-checked></svg-checked>
                            Paid
                        </label>
                    </span>
                    <span class="col-sm-3 bold" *ngIf="fee.waived">Waived</span>
                    <span class="col-sm-2">{{'$' + fee.amount}}</span>
                </div>
            </div>

            <div *ngIf="action == 'waive'">
                <div class="row m-b-sm m-r-none" *ngFor="let paidFee of waivableFees; let index = index;">
                    <div class="col-md-9">
                        <div class="img-checkbox">
                                <span>
                                    <input type="checkbox"
                                           id="feeWaivedDetailedView{{index}}"
                                           name="feeWaived{{index}}"
                                           [disabled]="paidFee.originallyWaived"
                                           [(ngModel)]="paidFee.waived">
                                    <label class="with-checkbox clickable" for="feeWaivedDetailedView{{index}}">
                                        <svg-checked></svg-checked>
                                        <span class="text-capitalize">{{paidFee.name}}</span>
                                    </label>
                                </span>
                        </div>
                    </div>
                    <div class="col-md-3 fourteenPixelText">
                        <span *ngIf="paidFee.pmtAtTime && getStartEndDayDifference() > 1">
                            {{getStartEndDayDifference() + ' x '}}
                        </span>
                        <span *ngIf="paidFee.pmtHourly && getStartEndHourDifference() > 1">
                            {{getStartEndHourDifference() + ' x '}}
                        </span>
                        <span>{{'$' + paidFee.amount}}</span>
                    </div>
                </div>
            </div>

            <hr *ngIf="action != 'history' && action != 'extend'">

            <div *ngIf="action == 'pay'">
                <div class="row m-b-sm m-r-none"
                     [ngStyle]="{'display': paidFee.active && !paidFee.waived ? '' : 'none'}" *ngFor="let paidFee of amenityFees">
                    <div *ngIf="paidFee.include">
                        <div class="col-md-9">
                            <label class="text-capitalize">{{paidFee.name}}</label>
                        </div>
                        <div class="col-md-3 fourteenPixelText">
                            <span *ngIf="paidFee.pmtAtTime && getStartEndDayDifference() > 1">
                                {{getStartEndDayDifference() + ' x '}}
                            </span>
                            <span *ngIf="paidFee.pmtHourly && getStartEndHourDifference() > 1">
                                {{getStartEndHourDifference() + ' x '}}
                            </span>
                            <span>{{'$' + paidFee.amount}}</span>
                        </div>
                    </div>
                </div>

                <div class="row m-b-sm sixteen-pixel-bold" *ngIf="getTotalRefundableValue() != '0.00'">
                    <div class="col-md-9">
                        <label>Total Refundable</label>
                    </div>
                    <div class="col-md-3 mtv-primary-color">
                        {{'$' + getTotalRefundableValue()}}
                    </div>
                </div>

                <div class="row m-b-sm sixteen-pixel-bold"
                     *ngIf="getReservationProcessingFeeValue() != '0.00' && data.paymentMethod == 'credit_card'">
                    <div class="col-md-9">
                        <label>Reservation Processing Fee</label>
                    </div>
                    <div class="col-md-3 mtv-primary-color">
                        {{'$' + getReservationProcessingFeeValue()}}
                    </div>
                </div>

                <div class="row m-b-sm sixteen-pixel-bold" *ngIf="getTotalCharged() != '0.00'">
                    <div class="col-md-9">
                        <label>Total Payment Due</label>
                    </div>
                    <div class="col-md-3 mtv-primary-color">
                        {{'$' + getTotalCharged()}}
                    </div>
                </div>
            </div>

            <div *ngIf="action == 'refund'">
                <div class="row">
                    <div class="col-md-12 m-b-sm">
                        <label>Reason For Refund</label>
                    </div>
                    <div class="col-md-12">
                        <textarea class="form-control" name="reason" maxlength="255" [(ngModel)]="refundReason">
                            Reason
                        </textarea>
                    </div>
                </div>
            </div>

            <div *ngIf="action == 'charge'">
                <div class="row">
                    <div class="col-md-9">
                        <label>Charge Amount {{getProcessingFee() ? ('(' + getProcessingFee() + '$ before processing fee)') : ''}}</label>
                    </div>
                    <div class="col-md-3">
                        <span class="fee-input-dollar">$</span>
                        <input name="charge"
                               (keypress)="validateFeeValue($event)"
                               style="max-width: 100%; outline: none;"
                               [(ngModel)]="chargeAmount">
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-md-12 m-b-xs">
                        <label>Reason For Charging</label>
                    </div>
                    <div class="col-md-12">
                        <textarea class="form-control" name="reason" maxlength="255" [(ngModel)]="chargeReason">
                            Reason
                        </textarea>
                    </div>
                </div>
            </div>
            <div *ngIf="action == 'history'" class="font-bold m-b-md">
                <div *ngFor="let item of history; let last = last;" class="row m-r-none">
                    <div class="col-md-9">
                        <span *ngIf="item.action === 'refund' && item.status">
                            Refund issued for
                        </span>
                        <span *ngIf="item.action === 'refund' && !item.status">
                            Failed to issue refund for
                        </span>
                        <span *ngIf="item.action === 'charge' && item.status">Charged Against</span>
                        <span *ngIf="item.action === 'charge' && !item.status">
                            Failed to charge against
                        </span>
                        <span *ngIf="item.action === 'pay' && item.status">
                            Paid for
                        </span>
                        <span *ngIf="item.action === 'pay' && !item.status">
                            Failed to pay for
                        </span>
                        <span *ngIf="item.action === 'expected_hold' && item.status">Hold for</span>
                        <span *ngIf="item.action === 'expected_hold' && !item.status">
                            Failed to do a hold for
                        </span>
                        {{item.name}}
                    </div>
                    <div class="col-md-3">${{item.amount}}</div>
                    <div class="col-md-12 font-normal twelve-pixels-font">
                        <i *ngIf="item.status" class="icon-check"></i>
                        <i *ngIf="!item.status" class="icon-close"></i>
                        {{item.description}}
                    </div>
                    <div class="col-md-12 twelve-pixels-font">
                        <span class="m-r-sm">{{item.createdBy}}</span>
                        {{item.createdAt | mccDate:true:true}}
                    </div>
                    <div class="col-md-12" *ngIf="!last"><hr></div>
                </div>
                <div *ngIf="history.length < 1" class="text-center">No History records found</div>
            </div>
            <div *ngIf="action == 'extend'">
                <div class="m-b-sm datepicker-wrapper" *ngIf="!hasHold()">
                    <div class="p-l-n col-md-4">
                        <label>Will be Held</label>
                    </div>
                    <mat-form-field class="col-md-8 m-n no-padding long-date-field">
                        <input matInput
                               [ngModel]="data.customRefundableHoldDate"
                               name="customRefundableHoldDate"
                               [matDatepicker]="holdPicker"
                               [min]="minDate"
                               [max]="data.dateFrom"
                               (focus)="holdPicker.open()"
                               (click)="holdPicker.open()"
                               (ngModelChange)="onStartDateChanged($event)"
                               placeholder="Choose a date" required>
                        <mat-datepicker-toggle matSuffix [for]="holdPicker"></mat-datepicker-toggle>
                        <mat-datepicker #holdPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="m-b-sm datepicker-wrapper">
                    <div class="p-l-n col-md-4">
                        <label>Will be Released</label>
                    </div>
                    <mat-form-field class="col-md-8 m-n no-padding long-date-field">
                        <input matInput
                               [ngModel]="data.customRefundableReleaseDate"
                               name="customRefundableReleaseDate"
                               [matDatepicker]="releasePicker"
                               [min]="minReleaseDate"
                               [disabled]="!form.value.customRefundableHoldDate && !hasHold()"
                               (focus)="releasePicker.open()"
                               (click)="releasePicker.open()"
                               placeholder="Choose a date" required>
                        <mat-datepicker-toggle matSuffix [for]="releasePicker"></mat-datepicker-toggle>
                        <mat-datepicker #releasePicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row text-center m-t-sm m-r-sm m-l-sm"
                 *ngIf="action != 'history' && amenitiesService.selectedItemData.isCanEdit">
                <button class="btn btn-primary submit-btn" type="submit" [disabled]="disabledSubmit">
                    Save
                </button>
            </div>

            <!-- ___ isPayByLink checkbox ___ -->
            <div class="m-t-sm" *ngIf="action == 'pay' && data.paymentMethod == 'credit_card' && !authService.userIsResident && data.residentEmail">
                <span class="mtv-primary-color" (click)="amenitiesService.sendPaymentLink(data)">
                    Send Payment Request
                </span>
            </div>
        </form>
    </div>
    <spinner [spinnerShow]="spinnerShow"></spinner>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenity-payment/amenities-payment.component.html